import { createSelector } from 'reselect';

const getSettings = state => state.settingsList.data;

const getSettingByName = name =>
  createSelector(
    getSettings,
    settings => settings && settings.find(setting => setting.name === name)
  );

const getTimeoutDuration = createSelector(
  getSettingByName('timeout'),
  setting => setting && setting.value
);

export { getSettings, getTimeoutDuration };
